<template>
  <div :class=" 'categorypage page ' + maincategory.slug">
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> <i class="icon icon-chevron-right"></i> <router-link :to="{ name: 'CategoriesPage', params: { q: maincategory.slug }}">{{maincategory.name}}</router-link>
        </div>
        <h1>{{maincategory.name}}</h1>
      </div>
    </div>    
    <div class="columns flex valign-top wrap third">
      <div class="column" v-for="(cat, i) in subcategories" :key="i" v-if="!cat.img.includes('halter') || user"> 
        <productpreview :cat="cat" :sync="cat"></productpreview>
      </div>
    </div>
  </div>
</template>
<script>
import Productpreview from '../views/Productpreview'
import categories     from '../data/categories.json';


export default {
    name: 'Detail',
    components: {
      Productpreview
    },
    data: function(){
      return {
         subcategories: [],
         maincategory: {}
      }
    },

    computed: {

         user () {
            return this.$store.state.authentication.user
        },  
      
    },
    
    created: function(){
      //console.log(this.items);
      this.filterResults()
      //console.log(this.product)
    },
    watch: {
    '$route.params.q': function (q) {
      this.filterResults()
      },
   
    },
    methods: {
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
      filterResults(){
          
          this.subcategories = []
          var q = this.$route.params.q;
          var subcategories = categories.filter( (category) => { return  category.slug == this.$route.params.q  });
          
                    
          if( subcategories.length > 0) { 
            
            this.maincategory = {name: subcategories[0].name, slug: subcategories[0].slug }

            
            subcategories[0].contains.forEach( (cat ) => {
              this.subcategories.push( cat )
            })
            

          } // if
      }
    }
}
</script>
<style>
  .subcategory { position: relative; display: block; }
  .subcategory .link-label { 
    position: absolute; top: 0; left: 0; text-transform: uppercase; 
    background: rgba(240,240,240,0); width: auto; white-space: nowrap; 
    color: #00853e;
    padding: 0.5633333rem 0.9333333rem 0.6333333rem  1.866666rem;
    line-height: 1rem;
    font-size: 0.8rem;
    font-weight: bold;
    }
  .subcategory .link-label:before { content: " "; height: 0.96666rem; width: 0.966666rem; position: absolute; top: 0.5533333em; left: 0.553333em; background: red; }
  .gemuese .subcategory .link-label:before { background: #0077bb; }
  .fruechte .subcategory .link-label:before { background: #ffcd1c; }
  .salate-kraeuter-mehr .subcategory .link-label:before { background: #50af47; }
  .convenience .subcategory .link-label:before { background: #793282; }
  .bio .subcategory .link-label:before { background: #e30613; }


  .subcategory .prod-img-container { overflow: hidden; width: 100%; }
  
  .subcategory img { display: block; width: 100%; transform: scale(1.01); transition: transform 0.3s ease-in-out; height: 50%;  }
  .subcategory img[src=""] { padding-top: 100%; visibility: hidden; }
  .subcategory:hover img { transform: scale(1.05); transition: transform 0.3s ease-in-out; }
/*
  .productpage .label { display: inline-block; min-width: 10em; }
  .productpage .product-info .p-detail { padding: 0.91333333em; border-top: 1px solid #ededef; }
  .productpage .product-info .p-detail:last-child { border-bottom: 1px solid #ededef; }
  .p-bio img { display: inline-block; max-width: 6em; }
*/
</style>
